import { useRouter } from '@/router/useRouter';
import { resolveVueInject } from '@tencent/ui-core/lib/utils/vue/resolveVueInject';
function firstFilled(candidates) {
    for (const [source, raw] of candidates) {
        if (typeof raw === 'number' && !Number.isNaN(raw))
            return [String(raw), source];
        if (typeof raw === 'string' && raw)
            return [raw, source];
    }
    return ['', 'none'];
}
/**
 * 解析页面片当前实际所处的流程上下文。
 *
 * 同一个页面片可以被多个流程 / 节点复用，所以运行时以「渲染它的那个页面」为准：
 * xy-page-container 在 type=flowNodePagelet 时已经算出了真实的 flowId / nodeId，
 * 页面入参里也带着真实的 jobId。插件配置只作为设计态（页面配置器里没有容器）
 * 和历史数据的兜底。
 */
export function resolveFlowPageContext(uc, config) {
    // uc.root 是 uc-renderer 自身，它没有 wContext；持有渲染容器的是外层的 w-sys-pagelet，
    // 而且插件安装时 uc.root 还没走完 inject，只能沿着 provide 链往上找
    const container = resolveVueInject(uc?.root, 'wContext')?.container;
    // 容器也可能在渲染普通页面或页面片，只有流程节点容器的配置才代表流程上下文
    const fromContainer = container?.type === 'flowNodePagelet' ? container.flowNodePageletConfig : null;
    const { route } = useRouter();
    const [flowId, flowIdSource] = firstFilled([
        ['container', fromContainer?.flowId],
        ['pluginConfig', config?.flowId],
    ]);
    const [nodeId, nodeIdSource] = firstFilled([
        ['container', fromContainer?.nodeId],
        ['pluginConfig', config?.nodeId],
    ]);
    const [jobId, jobIdSource] = firstFilled([
        ['container', container?.pageDataBase?.params?.jobId],
        ['route', route.value?.query?.jobId],
    ]);
    return {
        flowId,
        nodeId,
        jobId,
        sources: {
            flowId: flowIdSource,
            nodeId: nodeIdSource,
            jobId: jobIdSource,
        },
    };
}
